import { render, staticRenderFns } from "./LateralMenu.vue?vue&type=template&id=b3569316&scoped=true&"
import script from "./LateralMenu.vue?vue&type=script&lang=js&"
export * from "./LateralMenu.vue?vue&type=script&lang=js&"
import style0 from "./LateralMenu.vue?vue&type=style&index=0&id=b3569316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3569316",
  null
  
)

export default component.exports